import { stage } from "$lib/environment";
import type { ImportSummary } from "$lib/models/MasterdataDiff";
import {
  diffState,
  type DiffState,
  diffSummary,
} from "$lib/stores/masterdataStore";
import {
  errorDetails,
  type ErrorState,
  errorState,
} from "$lib/stores/errorState";

if (stage === "dev") {
  type stateType = {
    diffState: DiffState;
    diffSummary: ImportSummary | null;
    errorState: ErrorState;
    errorDetails: Error | unknown | null;
  };
  let state: stateType = {
    diffState: "Idle",
    diffSummary: null,
    errorState: "OK",
    errorDetails: null,
  };

  const debugDumpState = () => {
    console.log("📦 State Dump", state);
  };

  diffState.subscribe((value) => {
    console.log(`State change [diffState]: ${state.diffState} -> ${value}`);
    state = {
      ...state,
      diffState: value,
    };
    debugDumpState();
  });
  diffSummary.subscribe((value) => {
    console.log(`State change [diffSummary]: ${state.diffSummary} -> ${value}`);
    state = {
      ...state,
      diffSummary: value,
    };
    debugDumpState();
  });
  errorState.subscribe((value) => {
    console.log(`State change [errorState]: ${state.errorState} -> ${value}`);
    state = {
      ...state,
      errorState: value,
    };
    debugDumpState();
  });
  errorDetails.subscribe((value) => {
    console.log(
      `State change [errorDetails]: ${state.errorDetails} -> ${value}`,
    );
    state = {
      ...state,
      errorDetails: value,
    };
    debugDumpState();
  });
}
